"use client";

import React from "react";
import Lottie from "lottie-react";
import fileLoading from "./json/files-loading.json";
import cubeLoading from "./json/cube-loading.json";
import dotLoadingGray from "./json/dot-loader-gray.json";
import dotLoadingPrimary from "./json/dot-Loader-primary.json";
import guardSuccess from "./json/guard-success.json";
import creditCardLoading from "./json/credit-card.json";
import completed from "./json/completed.json";
import successCheck from "./json/success-check.json";
import generatingATS from "./json/generating.json";
import { Center, Text } from "@chakra-ui/react";

const animationDataMap = {
  fileLoading,
  cubeLoading,
  dotLoadingGray,
  dotLoadingPrimary,
  guardSuccess,
  completed,
  creditCardLoading,
  successCheck,
  generatingATS,
};

interface KnootLottieProps {
  animationName: keyof typeof animationDataMap;
  loop?: boolean;
  height?: string;
  width?: string;
  children?: React.ReactNode;
  text?: string;
}

export const KnootLottie = ({
  animationName,
  loop = true,
  height = "100%",
  width = "100%",
  children,
  text,
}: KnootLottieProps) => {
  return (
    <Center flexDir="column">
      <Lottie
        animationData={animationDataMap[animationName]}
        loop={loop}
        style={{ height: height, width: width }}
      />
      {children ||
        (text && (
          <Text
            textStyle="md"
            fontWeight="semibold"
            transform="translateY(-50px)"
          >
            {text}
          </Text>
        ))}
    </Center>
  );
};
